import Proveedores from "../layouts/AltaProveedores";
import ConsultaProveedores from "../layouts/ConsultaProveedores";
import LinkProveedores from "../layouts/Proveedores";
import Welcome from "../layouts/Welcome";
import Login from "../layouts/Login";
import LoginFederate from "../layouts/Extras/LoginFederate";
import LogoutFederate from "../layouts/Extras/LogoutFederate";


let appRoutes = [
  {
    id: 1,
    exact: true,
    private: false,
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    id: 2,
    exact: true,
    private: true,
    path: "/home",
    name: "Home",
    component: Welcome,
  },
  {
    id: 3,
    exact: true,
    private: true,
    path: "/home/altaProveedores",
    name: "Alta Proveedores",
    component: Proveedores,
  },
  {
    id: 5,
    exact: true,
    private: true,
    path: "/home/consultaProveedores",
    name: "Consulta Proveedores",
    component: ConsultaProveedores,
  },
  {
    id: 4,
    exact: true,
    private: false,
    path: "/home/proveedores/token/:token",
    name: "Link Proveedores",
    component: LinkProveedores,
  },
  {
    id: 6,
    exact: true,
    private: false,
    path: "/login-federado",
    name: "LoginFED",
    component: LoginFederate,
  },
  {
    id: 7,
    exact: true,
    private: true,
    path: "/logout-federado",
    name: "LogoutFED",
    component: LogoutFederate,
  }
];

export const homeRoutes = [  
  {
    id: 4,
    exact: true,
    showIntoMenu: false,
    path: "/home",
    name: "Bienvenida",
    shortName: "B",
    Component: Welcome,
  },    
  {
    id: 13,
    showIntoMenu: true,
    type: 'dropdown',
    name: "PROVEEDORES",
    shortName: "ALT",
    items: [
      { id: 131,
        path: "/home/altaProveedores",
        name: "Alta Proveedores"
      },
      { id: 132,
        path: "/home/consultaProveedores",
        name: "Consulta Proveedores"
      }      
    ]
  }
];

export default appRoutes;
